{
  "column": {
    "name": "Nombre",
    "type": "Tipo",
    "subscribedServices": "Servicios suscritos",
    "expirationDate": "Fecha de caducidad",
    "expirationDateFormat": "DD/MM/YYYY a HH:mm"
  },
  "addSingleCertificate": "Adición de un certificado",
  "addCertificate": "Añadir un certificado",
  "updateCertificate": "Actualizar el certificado",
  "certificate": {
    "typeTitle": "Tipo de certificado",
    "deviceTrustchain": "Device Trustchain",
    "pkiRootCa": "MS PKI root CA",
    "ldapsRootCa": "LDAPS root CA"
  },
  "caRestrictionInformation": "El certificado depositado debe ser un archivo .PEM y tener un tamaño inferior a 1 MB.",
  "dropCertificate": "Coloque el certificado aquí o haga clic aquí para seleccionarlo",
  "noCertificate": "No se ha inscrito ningún certificado en el marco de truststore",
  "validation": {
    "rootCa": "El certificado es obligatorio y debe tener el formato .PEM",
    "certType": "El tipo de certificado es obligatorio"
  }
}
